<template>
  <swiper
      :modules="modules"
      :breakpoints="breakpoints"
      :slides-per-view="4"
      :space-between="30"
      @swiper="onSwiper"
      :loop="true"
      :autoplay="{delay: 2000}"

      @slideChange="onSlideChange"
  >
    <swiper-slide>
        <a href="https://www.zadar.hr/" target="_blank">
            <img class="w-100" src="/img/logo-zadar-region.png" alt="Zadar region">
        </a>
    </swiper-slide>
    <swiper-slide>
         <a href="https://www.evisitor.hr/" target="_blank">
            <img class="w-100" src="/img/logo-evisitor.png" alt="eVisitor">
        </a>
    </swiper-slide>
    <swiper-slide>
         <a href="https://croatia.hr/" target="_blank">
            <img v-if="locale === 'hr'" class="w-100" src="/img/logo-hrvatske-turističke-zajednice-hr.png" alt="Hrvatska turistička zajednica">
            <img v-if="locale === 'en'" class="w-100" src="/img/logo-hrvatske-turističke-zajednice-en.png" alt="Hrvatska turistička zajednica">
        </a>
    </swiper-slide>
      <swiper-slide>
         <a href="https://mint.gov.hr/" target="_blank">
            <img class="w-100" src="/img/logo-mint.png" alt="Ministarstvo turizma i sporta Republike Hrvatske">
        </a>
    </swiper-slide>
      <swiper-slide>
         <a href="https://zadarbikemagic.com/" target="_blank">
            <img class="w-100" src="/img/logo-zadar-bike-magic.svg" alt="Zadar bike magic">
        </a>
    </swiper-slide>
  </swiper>
</template>
<script>
  // Import Swiper Vue.js components
  import { Swiper, SwiperSlide } from 'swiper/vue';

  // import required modules
  import { A11y, Autoplay } from "swiper";

  // Import Swiper styles
  import 'swiper/css';


  export default {
      components: {
          Swiper, SwiperSlide,
      },
      props: ['locale'],
      setup() {
          const onSwiper = (swiper) => {

          };
          const onSlideChange = () => {

          };
          return {
              onSwiper, onSlideChange, modules: [Autoplay, A11y],
          };
      },
      data() {
          return {
              breakpoints: {
                  1140: {
                      slidesPerView: 4,
                  },
                  1024: {
                      slidesPerView: 3,

                  },
                  768: {
                      slidesPerView: 3,
                  },
                  640: {
                      slidesPerView: 2,

                  },
                  480: {
                      slidesPerView: 1,
                  }
              }
          }
      },
  };
</script>

<style lang="scss">
.swiper-wrapper {
    align-items: center;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
}
.swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    > a {
        display: block;
        width: 180px;
        transition: transform .25s ease-in-out;
        will-change: transform;

        &:hover {
            transform: scale(1.02);
        }
    }
}
</style>
